import { render } from "./Transactions.vue?vue&type=template&id=4b764103&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=4b764103&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b764103"]])

export default __exports__